import Rules from './Rules';

class Rule {

    constructor(input, rule, attributes) {
        this.input = input;
        this.rule = rule;
        this.validators = new Rules(
            this.input,
            attributes
        );
    }

    validate() {
        if (!this.requiresValidation()) {
            return null;
        }
        return !this.validators[this.rule]() ? this.rule : null;
    }

    isRequired() {
        return this.input.rules.hasOwnProperty('required');
    }

    requiresValidation() {
        if (this.isRequired()) {
            return true;
        }
        if (this.rule === 'checked') {
            return true;
        }
        return this.rule !== 'checked' && this.validators.item().length > 0;
    }

}

export default Rule;